/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { IStore } from "../IStore";

export const getCurrentLocation = (state: IStore): string =>
  state.router.location.pathname + state.router.location.search;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrentLocationState = (state: IStore): any =>
  state.router.location.state;
